import { jwtDecode } from "jwt-decode";
import React, { useReducer, createContext } from "react";

const initialState = {
  idCliente: null,
};

const AuthContext = createContext({
  idCliente: null,
  login: (userData) => {},
  logout: () => {},
});

function authReducer(state, action) {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        idCliente: action.payload.idCliente,
      };
    case "LOGOUT":
      return {
        ...state,
        idCliente: null,
      };
    default:
      return state;
  }
}

function AuthProvider(props) {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const login = (userData) => {
    const { IdCliente, PrimerNombre, ...rest } = userData;

    dispatch({
      type: "LOGIN",
      payload: {
        idCliente: IdCliente,
        userName: PrimerNombre,
      },
    });
  };

  const logout = () => {
    window.location.href = "/";
    dispatch({
      type: "LOGOUT",
    });
  };

  return (
    <AuthContext.Provider
      value={{
        idCliente: state.idCliente,
        login,
        logout,
      }}
      {...props}
    />
  );
}

export { AuthContext, AuthProvider };
